// extracted by mini-css-extract-plugin
export default {"root":"Glossary_root__RPdEc","header":"Glossary_header__Ew33V","switchContainer":"Glossary_switchContainer__pWMVK"};